import { useState } from "react";
import { useDispatch } from "react-redux";
import WebLayout from "../../../layout/WebLayout";
import { toast } from "react-toastify";
import POProductAction from "../../../stores/actions/POProductAction";
import { useNavigate, useParams } from "react-router-dom";

const Payment = () => {
  const dispatch = useDispatch<any>();

  const navigate = useNavigate();

  const routeParams = useParams();
  const { id, price }: any = routeParams;

  const [loader, setLoader] = useState<boolean>(false);
  const [paymentReceipt, setPaymentReceipt] = useState<any>();

  const onSubmitFile = async () => {
    const inputFile = document.getElementById(
      "paymentReceipt"
    ) as HTMLInputElement;
    setPaymentReceipt(inputFile?.files?.item(0));
  };
  const formHandleSubmit = async (e: any) => {
    setLoader(true);
    e.preventDefault();

    try {
      await dispatch(
        POProductAction.createPoGenerate({
          receipt: paymentReceipt,
          id: id,
        })
      );
      navigate("/my-orders/placed");
      setLoader(false);
    } catch (error: any) {
      toast.error(error.message);
      setLoader(false);
    }
  };

  return (
    <WebLayout pageName={"Payment"}>
      <div className="content-wrapper">
        <div className="container-fluid flex-grow-1 container-p-y">
          <div className="card">
            <h5 className="card-header">
              <h5>Pay Amount After That Upload Payment Receipt And Submit</h5>
            </h5>
            <div className="card-body">
              <form
                className="dt_adv_search"
                method="POST"
                onSubmit={formHandleSubmit}
                encType={"multipart/form-data"}>
                <div className="row">
                  <div className="col-12">
                    <div className="row g-3">
                      {/* <div className="col-12 col-sm-12 col-lg-4">
                        <img
                          src={PAYMENT_QR}
                          alt="QR Payment"
                          className={"img-fluid"}
                        />
                      </div> */}
                      <div className="col-12 col-sm-12 col-lg-8">
                        <div className="mb-2">
                          <h4>
                            <mark>Indianmsme Account Details</mark>
                          </h4>
                          <p className="mb-2">
                            <b>ASC Distributor Pvt Ltd</b>
                          </p>
                          <p className="mb-2">
                            <b>Account No.: </b> 50200089652670
                          </p>
                          <p className="mb-2">
                            <b>IFSC Code: </b> HDFC0000886
                          </p>
                          <p className="mb-2">
                            <b>Bank Name: </b> HDFC Bank
                          </p>
                        </div>

                        <div
                          style={{
                            border: "1px solid",
                            padding: 5,
                            width: "40%",
                            textAlign: "center",
                          }}>
                          <b>Payment Amount</b>
                          <br />
                          <h2 className={"m-0"}>
                            Rs.{" "}
                            {JSON.parse(window.atob(price)).amount.toFixed(2)}
                          </h2>
                        </div>

                        <label className="form-label mt-2">
                          Upload Payment Receipt
                        </label>
                        <input
                          type="file"
                          id={"paymentReceipt"}
                          onChange={() => onSubmitFile()}
                          className={"form-control"}
                          required={true}
                        />
                        <button
                          type={"submit"}
                          className="btn btn-primary  mt-2"
                          disabled={loader}>
                          {loader ? (
                            <i className={"fa fa-spinner fa-spin"}></i>
                          ) : null}
                          Proceed to Payment
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
};

export default Payment;
